document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".csSwiper");

  if (!slider) return;

  new Swiper(".csSwiper", {

    slidesPerView: 1,

    spaceBetween: 25,

    speed: 700,

    loop: true,

    watchOverflow: true,

    grabCursor: true,

    centeredSlides: false,

    preloadImages: false,

    lazy: true,

    observer: true,

    observeParents: true,

    navigation: {

      nextEl: ".cs-next",

      prevEl: ".cs-prev",

    },

    autoplay: {

      delay: 4000,

      disableOnInteraction: false,

      pauseOnMouseEnter: true,

    },

    breakpoints: {

      0: {

        slidesPerView: 1,

        spaceBetween: 15,

      },

      576: {

        slidesPerView: 1.2,

        spaceBetween: 18,

      },

      768: {

        slidesPerView: 2,

        spaceBetween: 22,

      },

      992: {

        slidesPerView: 3,

        spaceBetween: 30,

      }

    }

  });

});